import React from 'react';
import { TransHtml, useLocale } from '../i18n/LocaleContext';
import { MiniAvatar } from './MiniApp';
import { analytics, WebAnalyticsEvent } from '../analytics/analyticsService';
import { useCountUp } from '../hooks/useCountUp';
import { VideoBackdrop } from './VideoBackdrop';
import { HERO_IMG, HERO_VIDEO } from '../data/pexels';

const scrollTo = (id: string): void => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

export const Hero = (): React.JSX.Element => {
  const { t } = useLocale();
  const [gatherers, countRef] = useCountUp(12400);

  return (
    <header className="hero hero--cine">
      <VideoBackdrop
        className="hero-cine-bg"
        src={HERO_VIDEO}
        poster={HERO_IMG}
      />
      <div className="hero-cine-scrim" />
      <div className="hero-glow hero-glow--a" />
      <div className="hero-glow hero-glow--b" />

      <div className="wrap hero-cine-inner">
        <span className="eyebrow eyebrow--neon">{t('hero.eyebrow')}</span>
        <TransHtml tag="h1" tKey="hero.h1" className="hero-cine-title" />
        <p className="lead hero-cine-lead">{t('hero.lead')}</p>

        <div className="hero-ctas">
          <button
            type="button"
            className="btn btn-primary btn-glow"
            onClick={() => {
              analytics.logEvent(WebAnalyticsEvent.CTA_CLICK, {
                location: 'hero_primary',
              });
              scrollTo('download');
            }}
          >
            {t('hero.cta1')}
          </button>
          <button
            type="button"
            className="btn btn-outline on-dark"
            onClick={() => {
              analytics.logEvent(WebAnalyticsEvent.CTA_CLICK, {
                location: 'hero_secondary',
              });
              scrollTo('features');
            }}
          >
            {t('hero.cta2')}
          </button>
        </div>

        <div className="hero-meta hero-meta--cine">
          <div className="avatars">
            <MiniAvatar first="Mia" last="K." size={34} />
            <MiniAvatar first="Tom" last="B." size={34} />
            <MiniAvatar first="Ana" last="D." size={34} />
            <MiniAvatar first="Sam" last="R." size={34} />
          </div>
          <div>
            <strong className="count-up" ref={countRef}>
              {gatherers.toLocaleString('en-US')}+
            </strong>{' '}
            <span>{t('hero.meta')}</span>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="hero-scrollcue"
        aria-label="Scroll down"
        onClick={() => scrollTo('features')}
      >
        <span />
      </button>
    </header>
  );
};
